export const upperFirst = (str) => str.slice(0, 1).toUpperCase() + str.slice(1);

export const removeWhiteSpace = (str) => str.replace(/\s+/g, '');
